const texts = {
    "header": {
        "de": "HARIBO in Kooperation mit Center Parcs",
        "fr": "HARIBO en coopération avec Center Parcs"
    },
    claim: {
        de: 'Haribo macht Kinder froh und Erwachsene ebenso!',
        fr: 'Haribo, c’est beau la vie, pour les grands et les petits&nbsp;!'
    },
    csrf: {
        copy: {
            de: 'Aus Sicherheitsgründen muss die Seite leider neu geladen werden. Bitte probiere es danach erneut.',
            fr: 'Pour des raisons de sécurité, la page doit malheureusement être rechargée. Veuillez réessayer ensuite.'
        },
        cta: {
            de: 'Seite neu laden',
            fr: 'Recharger la page'
        }
    },
    back: {
        de: 'Zurück',
        fr: 'Retour'
    },
    nav: {
        tnb: {
            de: 'Teilnahmebedingungen',
            fr: 'Conditions de participation'
        },
        imprint: {
            de: 'Impressum',
            fr: 'Mentions légales'
        },
        privacy: {
            de: 'Datenschutz',
            fr: 'Protection des données'
        },
        contact: {
            de: 'Kontakt',
            fr: 'Contact'
        }
    },
    privacy: {
        head: {
            de: 'Datenschutz&shy;erklärung',
            fr: 'Déclaration en matière de protection des données'
        },
        cookie: {
            de: 'Tracking-Einstellungen bearbeiten',
            fr: 'Modifier les paramètres de suivi'
        }
    },
    soon: {
        headline: {
            de: 'Bald geht\'s los!',
            fr: 'Coup d’envoi imminent !'
        },
        copy: {
            de: 'Ab dem 02.01.2026 Aktionscode eingeben und mit etwas Glück gewinnen.',
            fr: 'Dès le 02/01/2026, saisissez votre code de participation et, avec un peu de chance, remportez un prix.'
        },
        footnote: {
            de: '* weiterführende Informationen in den Teilnahmebedingungen',
            fr: "* plus d'informations dans les conditions de participation."
        }
    },
    over: {
        headline: {
            de: 'Unser Gewinnspiel ist seit dem 30.06.2026 beendet!',
            fr: 'Notre jeu-concours a pris fin le 30/06/2026 !'
        }, 
        copy1: {
            de: 'Vielen Dank an alle, die teilgenommen haben.',
            fr: 'Nous remercions sincèrement l’ensemble des participantes et participants.'
        },
        copy2: {
            de: 'Das nächste HARIBO-Gewinnspiel wartet schon!',
            fr: 'Le prochain jeu-concours HARIBO est déjà prévu !'
        },
        cta: {
            de: 'Mach mit!',
            fr: 'Participez !'
        }
    },
    to_code_input: {
        de: 'Direkt zur Code-Eingabe',
        fr: 'Saisie directe du code'
    },
    to_code_input_comment: {
        de: '*weiterführende Informationen in den Teilnahmebedingungen',
        fr: '*plus d\'informations dans les conditions de participation.'
    },
    intro: {
        baer: {
            de: '',
            fr: ''
        },        
        win: {
            de: 'Gewinne 1 von 111 Urlauben mit Center Parcs + viele Sofortgewinne',
            fr: 'Remportez l’un des 111 séjours proposés par Center Parcs + de nombreux prix immédiats'
        },
        head: {
            de: 'HARIBO naschen und gewinnen!',
            fr: 'Avec HARIBO, régalez-vous et gagnez !'
        },
        copy: {
            de: 'Sichere dir jetzt die Chance auf 1 von 111 Urlauben bei Center Parcs + zahlreiche Gutscheine für deinen nächsten Urlaub in einem Center Parcs Ferienpark.<br><br><strong>Jeder Aktionsbeutel = 1 Chance</strong>',
            fr: 'Tentez votre chance pour remporter l’un des 111 séjours Center Parcs en jeu + de nombreux bons d’achat pour vos prochaines vacances dans un domaine Center Parcs.<br><br><strong>Chaque sachet promotionnel = 1 chance</strong>'
        },
        bold: {
            de: 'Jeder Aktionsbeutel = 1 Chance',
            fr: 'Chaque sachet promotionnel = 1 chance'
        },
        to_code: {
            de: 'Direkt zur Code-Eingabe',
            fr: 'Accès direct à la saisie du code'
        },
        to_prizes: {
            de: 'Zu den Gewinnen',
            fr: 'Voir les prix'
        },
        cta: {
            de: 'Mach mit!',
            fr: 'Participe&nbsp;!'
        }   
    },
    sogehts: {
        head: {
            de: "So geht's",
            fr: "Voici comment ça marche"
        },
        de: [
            'Aktionsbeutel kaufen',
            'Aktionscode eingeben<br>und sofort erfahren,<br>ob du gewonnen hast',
            'Teilnahme bestätigen und<br>Chance auf Hauptpreis<br>sichern'
        ],
        fr: [
            'Achetez un sachet<br>promotionnel',
            'Saisissez votre code de parti-<br>cipation et découvrez immédia-<br>tement si vous avez gagné',
            'Confirmez votre participation<br>et augmentez vos chances de<br> remporter le premier prix'
        ]
    },
    code_position: {
        head: {
            de: 'Aktionscode',
            fr: 'Code promotionnel'
        },
        copy: {
            de: 'Der 10-stellige Aktionscode befindet sich auf der Innenseite des Beutels hinter dem außen auf&shy;gedruckten Hinweis „Code&nbsp;hier!“.',
            fr: "Le code promotionnel à 10 chiffres se trouve à l'intérieur du sachet, derrière la mention « Code hier! » imprimée à l'extérieur."
        },
        questions: {
            de: 'Noch Fragen?',
            fr: 'Encore des questions&nbsp;?'
        },
        to_faq: {
            de: 'Hier geht\'s zu den FAQs',
            fr: 'Voici la FAQ'
        },
        close: {
            de: 'Schließen',
            fr: 'Fermer'
        }
    },
    code_input: {
        head: {
            de: 'Jetzt Code eingeben und gewinnen!',
            fr: 'Saisissez votre code et gagnez !'
        },
        subline: {
            de: 'Du erfährst sofort, ob du gewonnen hast! Los geht\'s!',
            fr: 'Vous saurez immédiatement si vous avez gagné&nbsp;! C\'est parti&nbsp;!'
        },
        code_placeholder: {
            de: 'Aktionscode*',
            fr: 'Code promotionnel*'
        },
        email_placeholder: {
            de: 'E-Mail-Adresse',
            fr: 'Adresse e-mail'
        },
        position: {
            de: 'Wo finde ich den Aktionscode?',
            fr: 'Où puis-je trouver mon code promotionnel&nbsp;?'
        },
        getemail: {
            de: 'Doch an der Hauptpreis&shy;verlosung teilnehmen!',
            fr: 'Je participe au tirage au sort du grand prix !'
        },
        main_raffle: {
            de: 'Zur Teilnahme an der Hauptpreisverlosung benötigen wir deine E-Mail-Adresse.',
            fr: "Pour participer au tirage au sort du grand prix, vous devez nous communiquer votre adresse e-mail."
        },
        noemail: {
            de: 'Ich möchte keine E-Mail-Adresse angeben und nicht an der Hauptpreisverlosung teilnehmen.',
            fr: "Je ne souhaite pas communiquer mon adresse e-mail ni participer au tirage au sort du grand prix."
        },
        mandatory: {
            de: '* Pflichtfelder',
            fr: '* Champs obligatoires'
        },
        accept_terms: {
            de: 'Bitte akzeptiere die Teilnahmebedingungen.',
            fr: 'Veuillez accepter les conditions de participation.'
        },
        code_failed: {
            de: 'Der eingegebene Code ist ungültig.',
            fr: 'Veuillez accepter les conditions de participation.'
        },
        code_failed_cta: {
            de: 'Bitte gib einen gültigen Code ein.',
            fr: 'Veuillez saisir un code valide. '
        },
        code_already: {
            de: 'Dieser Code wurde bereits eingelöst.',
            fr: 'Ce code a déjà été utilisé.'
        },
        code_timeout: {
            de: 'Bitte versuche es später noch einmal.',
            fr: 'Veuillez réessayer ultérieurement.'

        },
        code_throttle: {
            de: 'Du hast zu oft einen falschen Code eingegeben. Bitte versuche es später noch einmal.',
            fr: 'Vous avez entré un code incorrect trop de fois. Veuillez réessayer plus tard.'

        },
        code_limit: {
            de: 'Du kannst nur 10 Codes pro Tag einlösen.',
            fr: 'Vous ne pouvez échanger que 10 codes par jour.'
        },
        captcha: {
            de: 'Bitte aktivieren Sie den FriendlyCaptcha',
            fr: 'Veuillez activer le FriendlyCaptcha'
        },
        email_missing: {
            de: 'Bei Auswahl der Checkbox „Anmeldung zum HARIBO-Newsletter” benötigen wir deine E-Mail-Adresse.',
            fr: 'En cochant la case « Inscription à la newsletter HARIBO », nous avons besoin de votre adresse e-mail.'
        },
        email_invalid: {
            de: 'Die E-Mail ist ungültig.',
            fr: 'L\'adresse e-mail est invalide.'
        },
        submit: {
            de: 'Jetzt mitmachen!',
            fr: 'Je participe !'
        }
    },
    gewinne: {
        head: {
            de: 'Hauptgewinne',
            fr: 'Premiers prix'
        },
        subline: {
            de: '111 x Urlaub in einem Park von',
            fr: '111 séjours dans un domaine'
        },
        intro: {
            de: 'Urlaub mitten in der Natur mit Center Parcs',
            fr: 'Des vacances en pleine nature avec Center Parcs'
        },
        copy: {
            de: 'Erlebe unvergessliche Urlaubsmomente bei Center Parcs. <span>Ob Nervenkitzel auf der Wasserrutsche im Aqua Mundo, gemütliche Spieleabende auf der Ferienhausterrasse oder tierische Begegnungen auf dem Kinderbauernhof: Bei Center Parcs gestaltest du deinen Urlaub ganz nach deinen Wünschen.<br><br>Du möchtest Abenteuer und Erholung erleben? Dann nutze deine Chance und gewinne 1 von 111 Hauptgewinnen: Ein Urlaub in einem Comfort- oder Premium-Ferienhaus für bis zu 6 Personen und 4 Nächten (Mo-Fr oder Fr-Mo) in einem Ferienpark deiner Wahl in Deutschland, Frankreich, Belgien oder den Niederlanden (ausgenommen Park Sandur und Terhills Resort).<br><br>Mach mit - vielleicht verbringst du deinen nächsten Urlaub schon bald mit deinen Liebsten inmitten schönster Natur!</span>',
            fr: 'Vivez des vacances inoubliables à Center Parcs. <span>Sensations fortes sur les toboggans aquatiques d’Aqua Mundo, soirées jeux conviviales sur la terrasse de votre hébergement ou rencontres avec les animaux de la ferme pédagogique : à Center Parcs, vous organisez vos vacances au gré de vos envies.<br><br>Souhaitez-vous vivre une expérience alliant aventure et détente ? Alors tentez votre chance et remportez l’un des 111 premiers prix : un séjour en cottage « Comfort » ou « Premium » pouvant accueillir jusqu’à 6 personnes pour 4 nuits (du lundi au vendredi ou du vendredi au lundi) dans le domaine de votre choix en Allemagne, en France, en Belgique ou aux Pays-Bas (à l’exception des villages Sandur et Terhills Resort).<br><br>Participez : vous passerez peut-être bientôt vos prochaines vacances avec vos proches dans un magnifique écrin de nature !</span>'
        },
        copy_open: {
            de: 'mehr Infos anzeigen',
            fr: 'afficher plus d’informations'
        },
        copy_close: {
            de: 'weniger Infos anzeigen',
            fr: 'afficher moins d’informations'
        },
        instant_head: {
            de: 'Sofortgewinne',
            fr: 'Prix immédiats'
        },
        instant_alt: {
            de: 'Gewinne einen von 100 Center Parcs Gutscheinen im Wert von 100 € oder einen von 500 Gutscheinen im Wert von 50 €',
            fr: '100 chèques-cadeaux Center Parcs de 100 €. 500 chèques-cadeaux Center Parcs de 50 €'
        },
        instant_intro: {
            de: 'Nasch dich ins Abenteuer und gewinne einen Gutschein für deinen nächsten Urlaub in einem Center Parcs Ferienpark!',
            fr: 'Lancez-vous dans l’aventure en vous régalant de douceurs et remportez un chèque-cadeau pour vos prochaines vacances dans un domaine Center Parcs.'
        },
        instant_copy: {
            de: 'Erfahre sofort, ob du einen Reisegutschein im Wert von 100&nbsp;€ / 100&nbsp;₣ oder 50&nbsp;€ / 50&nbsp;₣  gewonnen hast.',
            fr: 'Découvrez vite si vous avez gagné un chèque-cadeau voyage d’une valeur de 100&nbsp;€ / 100&nbsp;₣ ou 50&nbsp;€ / 50&nbsp;₣.'
        },
        image_alt: {
            de: 'Bilder vom Centerparcs mit verschiedenen Center Parcs Ferienparks und glücklichen Familien',
            fr: 'Images de Center Parcs avec différents parcs de vacances Center Parcs et des familles heureuses'
        }
    },
    support: {
        faq_head: {
            de: 'FAQs',
            fr: 'FAQ'
        },
        head: {
            de: 'Du hast noch weitere Fragen?',
            fr: "Vous avez d’autres questions ?"
        },
        copy: {
            de: 'Dann nimm gerne Kontakt mit uns auf. Telefonisch erreichst du uns montags bis freitags von 8:30 Uhr bis 17:30 Uhr unter<br><span class="nobreak"><a href="tel:+4926418299993">+49 2641 - 8 29 99 93</a></span>.<br><br>Oder schreibe uns einfach eine E-Mail an<br><a href="mailto:centerparcs@promotion.haribo.com">centerparcs@promotion.haribo.com</a>.<br><br><strong>Wir helfen dir gerne weiter.',
            fr: 'Alors n’hésitez pas à nous contacter. Nous sommes joignables par téléphone du lundi au vendredi, de 8 h 30 à 17 h 30, au <br><span class="nobreak"><a href="tel:+4926418299993">+49 2641 - 8 29 99 93</a></span>.<br><br>Tu peux aussi nous envoyer un e-mail à<br><a href="mailto:centerparcs@promotion.haribo.com">centerparcs@promotion.haribo.com</a>.<br><br><strong>Nous nous ferons un plaisir de t\'aider.</strong>'
        }
    },
    won: {
        head: {
            de: 'YEAH! Gewonnen!',
            fr: 'BRAVO! C’est gagné !'
        },
        head_alt: {
            de: 'Juhu! Gewonnen!',
            fr: 'BRAVO! C’est gagné !'
        },
        copy: {
            de: '',
            fr: ''
        },
        prize: {
            1: {
                de: 'Center Parcs Gutschein im Wert von 50 €',
                fr: 'Bon Center Parcs d\'une valeur de 50&nbsp;€'
            },
            2: {
                de: 'Center Parcs Gutschein im Wert von 100 €',
                fr: 'Bon Center Parcs d\'une valeur de 100&nbsp;€'
            }
        },
        enter_name: {
            de: 'Jetzt Namen eingeben',
            fr: 'Entrez votre nom maintenant'
        },
        voucher_alt: {
            de: 'Center Parcs Gutschein im Wert von ',
            fr: 'Coupon Center Parcs d\'une valeur de'
        },
        get_voucher: {
            de: 'Jetzt Gutschein sichern',
            fr: 'Accès à votre chèque-cadeau'
        },
        enter_credentials_1: {
            de: 'Wähle dein Land aus und gib deinen Vor- und Nachnamen ein. Anschließend kannst du deinen persönlichen Center Parcs‑Gutschein im Wert von ',
            fr: 'Sélectionnez votre pays et saisissez vos prénom et nom. Vous pourrez ensuite télécharger votre chèque-cadeau Center Parcs personnel de '
        },
        enter_credentials_2: {
            de: ' herunterladen.',
            fr: ' .'
        },
        enter_raffle: {
            de: 'Möchtest du deinen Center Parcs-Gutschein zusätzlich per E-Mail erhalten? Dann verrate uns deine E-Mail Adresse.',
            fr: 'Souhaitez-vous également recevoir votre bon Center Parcs par e-mail&nbsp;? Alors donne-nous votre adresse e-mail.'
        },
        firstname: {
            de: 'Vorname*',
            fr: 'Prénom*'
        },
        lastname: {
            de: 'Nachname*',
            fr: 'Nom*'
        },
        email: {
            de: 'E-Mail',
            fr: 'Adresse e-mail'
        },
        error_name: {
            de: 'Bitte gib deinen Vor- und Nachnamen ein.',
            fr: 'Veuillez saisir votre prénom et votre nom de famille.'
        },
        email_missing: {
            de: 'Bitte gib deine E-Mail-Adresse ein.',
            fr: 'Veuillez saisir votre adresse e-mail.'
        },
        email_invalid: {
            de: 'Die E-Mail ist ungültig.',
            fr: 'L\'adresse e-mail est invalide.'
        },
        submit: {
            de: 'Weiter zum Gutschein',
            fr: 'Accès à votre chèque-cadeau'
        },
        download_headline: {
            de: 'Jetzt Gutschein herunterladen und speichern!',
            fr: 'Téléchargez et enregistrez votre chèque-cadeau !'
        },
        download_button: {
            de: 'Gutschein herunterladen',
            fr: 'Télécharger le chèque-cadeau'
        },
        cta_partner: {
            de: 'Jetzt schon den nächsten Urlaub <br>aussuchen: ',
            fr: 'Choisissez déjà vos prochaines <br>vacances : ',
        },
        more_codes: {
            head: {
                de: 'Du hast noch einen Code?&nbsp;<br>Na dann los!',
                fr: 'Vous disposez d’un autre code ?<br>Alors c’est parti !'
            },
            cta: {
                de: 'Weiteren Code eingeben',
                fr: 'Saisir un autre code'
            }
        },
        error_country: {
            de: 'Bitte wähle dein Land aus.',
            fr: 'Veuillez sélectionner votre pays.'
        },
        select_country: {
            de: 'Land wählen',
            fr: 'Sélectionnez votre pays'
        },
        de: {
            de: 'Deutschland',
            fr: 'Allemagne'
        },
        at: {
            de: 'Österreich',
            fr: 'Autriche'
        },
        ch: {
            de: 'Schweiz',
            fr: 'Suisse'
        }
    },
    blank: {
        head: {
            de: 'Schade!',
            fr: 'Quel dommage !'
        },
        subline: {
            de: 'Diesmal hast du leider nicht gewonnen.',
            fr: 'Cette fois-ci, vous n’avez malheureusement pas gagné.'
        },
        copy: {
            de: 'Sichere dir jetzt die Chance auf den Hauptgewinn! Öffne deine E-Mail und bestätige deine Teilnahme. Mit mit etwas Glück gewinnst du 1 von 111 Urlauben mit Center Parcs.',
            fr: 'Tentez vite votre chance pour remporter le premier prix !<br><br>Ouvrez votre e-mail et confirmez votre participation. Avec un peu de chance, vous remporterez l’un des 111 séjours proposés par Center Parcs.'
        },
        more_codes: {
            head: {
                de: 'Du hast noch einen Code?&nbsp;<br>Na dann los!',
                fr: 'Vous disposez d’un autre code ?<br><br>Alors c’est parti !'
            },
            cta: {
                de: 'Weiteren Code eingeben',
                fr: 'Saisir un autre code'
            }
        }
    },
    mafo: {
        head: {
            de: 'STEHT DIREKT IM CODE',
            fr: 'SE TROUVE DIRECTEMENT DANS LE CODE'
        },
        copy: {
            de: 'Die Beantwortung ist freiwillig und deine Antworten werden anonym behandelt.',
            fr: 'Celles-ci sont facultatives et vos réponses seront traitées anonymement.'
        },
        danke: {
            de: 'Vielen Dank für deine Antworten.<br>Finde dein perfektes Abenteuer bei Center Parcs!',
            fr: "Merci beaucoup pour tes réponses."
        }
    },
    doi: {
        thanks: {
            de: 'Vielen Dank',
            fr: 'Merci à vous !'
        },
        done: {
            head: {
                de: 'Deine Teilnahme ist bestätigt.',
                fr: 'Votre participation est confirmée.'
            },
        },
        already: {
            head: {
                de: 'Deine Teilnahme ist bereits bestätigt.',
                fr: 'Votre participation est confirmée.'
            },
        },
        error: {
            head: {
                de: 'Deine Teilnahme war bereits bestätigt.',
                fr: 'Votre participation est confirmée.'
            },
        },
        copy: {
            de: 'Du möchtest weitere Codes eingeben?',
            fr: 'Vous disposez d’un autre code ? Mettez toutes les chances de votre côté pour remporter d’autres prix'
        },
        cta: {
            de: 'Weiteren Code eingeben',
            fr: 'Saisir un autre code'
        }
    },
    products: {
        headline: {
            de: 'Unsere HARIBO<br>Produktvielfalt entdecken',
            fr: 'Découvrir la diversité<br>de nos produits HARIBO'
        },
        more: {
            de: 'Mehr erfahren',
            fr: 'En savoir plus'
        },
        head: {
            de: 'Unsere Aktionsprodukte',
            fr: 'Nos produits de participation'
        },
        copy: {
            de: 'Unsere Aktionsbeutel sind deutlich durch ein besonderes Design und die bunten Ecken zu erkennen. Der 10-stellige Aktionscode befindet sich auf der Innenseite des Aktionsbeutels hinter dem außen aufgedruckten Hinweis – „Code hier!“.',
            fr: "Nos produits en promotion sont clairement reconnaissables à leur design particulier et à leurs coins colorés. Le code promotionnel à 10 chiffres se trouve à l'intérieur du sachet promotionnel, derrière la mention imprimée à l'extérieur  « Code hier! »."
        },
        shop: {
            de: 'Jetzt bestellen!',
            fr: 'Commander maintenant&nbsp;!'
        },
        cta: {
            de: 'Entdecke noch mehr HARIBO-Vielfalt auf unserer Website!',
            fr: 'Découvre encore plus de diversité HARIBO sur notre site web&nbsp;!'
        }
    }
}

export default texts;
